import { AuthContext, AuthContextType, useAsync, useRequiredParams } from '../../../utilities/customHooks';
import LoadingIndicator from '../../../Components/LoadingIndicator';
import ErrorIndicator from '../../../Components/ErrorIndicator';
import { getSowDetailsForInvoice } from '../../../services/serviceProvider';
import * as T from "../../../utilities/frontendTypes";
import { useState } from 'react';
import Button from '../../../Components/Button';

function CreateInvoice() {
    const [retainer, setRetainer] = useState(true)
    const [chooseSowType, setChooseSowType] = useState(true)
    const sowId = useRequiredParams("sowId");
    const sowRequestDetailsAsync = useAsync(() => getSowDetailsForInvoice(sowId), []);

    if (sowRequestDetailsAsync.status === "pending") {
      return <LoadingIndicator />;
    }
  
    if (sowRequestDetailsAsync.status === "rejected") {
      return <ErrorIndicator />;
    }
  
  const sow = sowRequestDetailsAsync.value.sow;
  const paymentDetails = sowRequestDetailsAsync.value.providerPaymentDetails;
  
  let totalPayment = 0
  
  if (sow.payment) {
    sow.payment.reduce((sum, item) => {
      return sum + (item.paymentAmount || 0);
    }, 0);
  }
    
  const handleSetFinal = () => {
    setChooseSowType(false)
    setRetainer(false)
  }

  return (
    <div className="resourcesCont !top-0">
      {
      chooseSowType ?
        <div className='w-full flex flex-col'>
          <h2>What kind of invoice would you like to submit?</h2>
          <div className='w-full flex flex-col gap-4'>
          <Button
            buttonText='Retainer'
            actionHandler={() => setChooseSowType(false)}
          />
          <Button
            buttonText='Final'
            actionHandler={() => handleSetFinal()}
          />
          </div>
        </div>
      :
        <div className='w-full flex flex-col'>
          {retainer &&
            <div>
              <div>
                <p className='font-semibold'>Payment Details:</p>
                {paymentDetails === null
                ?
                <div className='w-full flex flex-col'>

                </div>
                :
                <div className='w-full flex flex-col'>
                  <div className='w-full flex flex-col p-4' id="RetainerInvoice">
                    <div className='bodyLarger w-full flex justify-between border-border border-b'>
                      <p>Total on Statement of Work:</p>
                      <p>${totalPayment}</p>
                    </div>
                    <div className='bodyLarger w-full flex justify-between'>
                      <p>50% Retainer</p>
                      <p>${totalPayment}</p>
                    </div>
                  </div>
                </div>
                }
              </div>
            </div>
          }          
          {!retainer &&
            <div className='w-full flex flex-col'>
              <div className='w-full flex flex-col p-4' id="Invoice">
                
              </div>
            </div>
          }
        </div>
      }
    </div>
  )
}

export default CreateInvoice